<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit  Sub Category
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Sub Category Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !form.name"
            @click="save"
          >
            Update Sub Category
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryEditPage",
  data() {
    return {
      form: {
        name: "",
      },
              subcategories: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
   

    async getData() {
      this.isLoading = true;
      const subcategoryId = this.$route.params.subcategoryId;

      try {
        const response = await axios.get(`/subcategories/${subcategoryId}`);
        this.form = response.data.data;
        console.log("Subcategory data:", this.form);
      } catch (error) {
        console.error("Error fetching subcategory data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async save() {
      this.isLoading = true;
      const subcategoryId = this.$route.params.subcategoryId;
      // const categoryId = this.$route.params.categoryId;
      try {
        await axios.patch(`/subcategories/${subcategoryId}`, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (error) {
        console.error("Error updating category:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  padding: 20px;
}
</style>
